import { CHILD_TYPE_INVALID, Fragment, NODE_MISSING_FRAGMENT, Schema } from '@gitbook/slate';

import { createParagraph } from '../paragraph';
import {
    BLOCK_EXPANDABLE,
    BLOCK_PARAGRAPH,
    FRAGMENT_EXPANDABLE_BODY,
    FRAGMENT_EXPANDABLE_TITLE,
} from '../types';
import { FRAGMENT_ALLOWED_BLOCKS } from '../utils';

/**
 * Schema to validate expandable nodes.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_EXPANDABLE]: {
            isVoid: true,
            data: {
                defaultExpanded: (defaultExpanded) =>
                    defaultExpanded === undefined || typeof defaultExpanded === 'boolean',
            },
            fragments: {
                nodes: [{ objects: ['block'] }],
                keys: {
                    [FRAGMENT_EXPANDABLE_TITLE]: FRAGMENT_EXPANDABLE_TITLE,
                    [FRAGMENT_EXPANDABLE_BODY]: FRAGMENT_EXPANDABLE_BODY,
                },
                types: {
                    [FRAGMENT_EXPANDABLE_TITLE]: {
                        min: 1,
                        max: 1,
                        nodes: [
                            {
                                objects: ['block'],
                                types: [BLOCK_PARAGRAPH],
                                min: 1,
                                max: 1,
                            },
                        ],
                    },
                    [FRAGMENT_EXPANDABLE_BODY]: {
                        min: 1,
                        max: 1,
                        nodes: [
                            {
                                objects: ['block'],
                                types: FRAGMENT_ALLOWED_BLOCKS[FRAGMENT_EXPANDABLE_BODY],
                                min: 1,
                            },
                        ],
                    },
                },
            },
            fragmentParent: {
                objects: ['document'],
            },
            normalize: Schema.createNormalize({
                [CHILD_TYPE_INVALID]: (change, context) => {
                    change.replaceNodeByKey(context.child.key, createParagraph(context.child.text));
                },
                [NODE_MISSING_FRAGMENT]: (change, context) => {
                    const { node, key } = context;
                    if (node.object !== 'block') {
                        return;
                    }

                    if (key === FRAGMENT_EXPANDABLE_TITLE) {
                        return change.setFragmentByKey(
                            node.key,
                            Fragment.create({
                                // we have imported documents where the fragment `key` were set to this value,
                                // instead of the fragment `fragment` key. They may require normalization if we notice
                                // those blocks export or render improperly,  since this logic might not be fully
                                // backwards compatible.
                                fragment: FRAGMENT_EXPANDABLE_TITLE,
                                type: FRAGMENT_EXPANDABLE_TITLE,
                                nodes: [createParagraph()],
                            })
                        );
                    }

                    if (key === FRAGMENT_EXPANDABLE_BODY) {
                        return change.setFragmentByKey(
                            node.key,
                            Fragment.create({
                                fragment: FRAGMENT_EXPANDABLE_BODY,
                                type: FRAGMENT_EXPANDABLE_BODY,
                                nodes: [createParagraph()],
                            })
                        );
                    }
                },
            }),
        },
    },
});
